const mutations = {
  setWidth(state, value) {
    state.screenWidth = value;
  },
  setHeight(state, value) {
    state.screenHeight = value;
  },
  setFromAddress(state, value) {
    state.fromAddress = value;
  },
  SET_ACTIVE_ROUTE(state, value) {
    state.activeRoute = value
  },
  setIsLogin(state, value) {
    state.isLogin = value
  }
};

export default mutations;
